export default "__VITE_ASSET__430a2389__"